import { PositionFilterChoice } from '../../pages/protocol-view/usePositionFilter.ts';
import { RadioGroup } from '../radioGroup.tsx';


interface Props {
    value: PositionFilterChoice;
    options: PositionFilterChoice[];
    onChange: (value: PositionFilterChoice) => void;
}

/**
 * Filter visible positions by measurement variant.
 */
export function PositionFilterControl({
    value,
    options,
    onChange,
}: Props) {
    if (options.length <= 1) return null;

    const items = options.map(value => ({
        value,
        label: value === 'all' ? 'All' : value,
    }));

    return (
        <div className='protocol-position-filter'>
            <RadioGroup
                name='position-filter'
                header='Positions'
                items={items}
                value={value}
                onChange={onChange}
            />
        </div>
    );
}
